<template>
  <div class="fuel">
    <v-card>
      <!-- <img src='https://avataaars.io/?avatarStyle=Circle&topType=ShortHairShortRound&accessoriesType=Blank&hairColor=BrownDark&facialHairType=BeardMedium&facialHairColor=Black&clotheType=Hoodie&clotheColor=Heather&eyeType=Happy&eyebrowType=Default&mouthType=Serious&skinColor=Light'/> -->
      <!-- <img src= 'https://avataaars.io/?avatarStyle=Circle&topType=ShortHairShortWaved&accessoriesType=Blank&hairColor=BlondeGolden&facialHairType=Blank&clotheType=ShirtCrewNeck&clotheColor=Red&eyeType=Happy&eyebrowType=Default&mouthType=Default&skinColor=Pale'/> -->
      <v-card-title class="headline font-weight-regular blue-grey white--text">
        Meal Schedule
      </v-card-title>
      <!-- Schedule Table -->
    </v-card>
    <v-card class="table-card">
      <table border=0 style="border: 1px solid black">
        <tr>
          <th></th>
          <th>Morning<br>Stack</th>
          <th>Breakfast</th>
          <th>Morning<br>Snack</th>
          <th>Afternoon<br>Stack</th>
          <th>Lunch</th>
          <th>Afternoon<br>Snack</th>
          <th>Evening<br>Stack</th>
          <th>Dinner</th>
          <th>Evening<br>Snack</th>
          <th>Summary</th>
        </tr>
        <tr v-for="day in orderedPlan" v-bind:key="day.day" v-bind:class="highlight(day.day)">
          <td>
            <strong>{{ day.name }}</strong><br>
            <span v-bind:class="day.ronan.breakfast.name ? 'avatar' : 'avatar ghost'"><img src= 'https://avataaars.io/?avatarStyle=Circle&topType=ShortHairShortWaved&accessoriesType=Blank&hairColor=BlondeGolden&facialHairType=Blank&clotheType=ShirtCrewNeck&clotheColor=Red&eyeType=Happy&eyebrowType=Default&mouthType=Default&skinColor=Pale'/></span>
            <span class="avatar"><img src='https://avataaars.io/?avatarStyle=Circle&topType=ShortHairShortRound&accessoriesType=Blank&hairColor=BrownDark&facialHairType=BeardMedium&facialHairColor=Black&clotheType=Hoodie&clotheColor=Heather&eyeType=Happy&eyebrowType=Default&mouthType=Serious&skinColor=Light'/></span>
            <span v-bind:class="day.ronan.dinner.name ? 'avatar' : 'avatar ghost'"><img src= 'https://avataaars.io/?avatarStyle=Circle&topType=ShortHairShortWaved&accessoriesType=Blank&hairColor=BlondeGolden&facialHairType=Blank&clotheType=ShirtCrewNeck&clotheColor=Red&eyeType=Happy&eyebrowType=Default&mouthType=Default&skinColor=Pale'/></span>
            <span class="activity"></span>
            <span v-bind:class="day.judo ? 'avatar':'avatar ghost'" class="avatar avatar-sm"><img src= 'https://firebasestorage.googleapis.com/v0/b/aaron-farr-website.appspot.com/o/judo3.png?alt=media&token=04022291-ee1c-4c09-bba5-880c51e32079'/></span>
            <span v-bind:class="day.sambo ? 'avatar':'avatar ghost'" class="avatar avatar-sm ml-1"><img src= 'https://firebasestorage.googleapis.com/v0/b/aaron-farr-website.appspot.com/o/sambo.png?alt=media&token=c18e1f9a-9bf5-4aa4-9c77-4911a7bea9f8'/></span>
            <router-link to="{ name: 'Shopping' }" v-if="day.groceries" class="groceries">Groceries</router-link>
          </td>
          <td>
            <template v-if="day.aaron.morningStack.name">
              <span class="dad">{{ day.aaron.morningStack.name }}</span>
            </template>
            <template v-if="!day.aaron.morningStack.name">
              <span class="none">-</span>
            </template>
            <br>
            <template v-if="day.ronan.morningStack.name">
              <span class="ronan">{{ day.ronan.morningStack.name }}</span>
            </template>
            <template v-if="!day.ronan.morningStack.name">
              <span class="none">-</span>
            </template>
          </td>
          <td>
            <template v-if="day.aaron.breakfast.name">
              <span class="dad">{{ day.aaron.breakfast.name }}</span>
            </template>
            <template v-if="!day.aaron.breakfast.name">
              <span class="none">-</span>
            </template>
            <br>
            <template v-if="day.ronan.breakfast.name">
              <span class="ronan">{{ day.ronan.breakfast.name }}</span>
            </template>
            <template v-if="!day.ronan.breakfast.name">
              <span class="none">-</span>
            </template>
          </td>
          <td>
            <template v-if="day.aaron.morningSnack.name">
              <span class="dad">{{ day.aaron.morningSnack.name }}</span>
            </template>
            <template v-if="!day.aaron.morningSnack.name">
              <span class="none">-</span>
            </template>
            <br>
            <template v-if="day.ronan.morningSnack.name">
              <span class="ronan">{{ day.ronan.morningSnack.name }}</span>
            </template>
            <template v-if="!day.ronan.morningSnack.name">
              <span class="none">-</span>
            </template>
          </td>
          <td>
            <template v-if="day.aaron.afternoonStack.name">
              <span class="dad">{{ day.aaron.afternoonStack.name }}</span>
            </template>
            <template v-if="!day.aaron.afternoonStack.name">
              <span class="none">-</span>
            </template>
            <br>
            <template v-if="day.ronan.afternoonStack.name">
              <span class="ronan">{{ day.ronan.afternoonStack.name }}</span>
            </template>
            <template v-if="!day.ronan.afternoonStack.name">
              <span class="none">-</span>
            </template>
          </td>
          <td>
            <template v-if="day.aaron.lunch.name">
              <span class="dad">{{ day.aaron.lunch.name }}</span>
            </template>
            <template v-if="!day.aaron.lunch.name">
              <span class="none">-</span>
            </template>
            <br>
            <template v-if="day.ronan.lunch.name">
              <span class="ronan">{{ day.ronan.lunch.name }}</span>
            </template>
            <template v-if="!day.ronan.lunch.name">
              <span class="none">-</span>
            </template>
          </td>
          <td>
            <template v-if="day.aaron.afternoonSnack.name">
              <span class="dad">{{ day.aaron.afternoonSnack.name }}</span>
            </template>
            <template v-if="!day.aaron.afternoonSnack.name">
              <span class="none">-</span>
            </template>
            <br>
            <template v-if="day.ronan.afternoonSnack.name">
              <span class="ronan">{{ day.ronan.afternoonSnack.name }}</span>
            </template>
            <template v-if="!day.ronan.afternoonSnack.name">
              <span class="none">-</span>
            </template>
          </td>
          <td>
            <template v-if="day.aaron.eveningStack.name">
              <span class="dad">{{ day.aaron.eveningStack.name }}</span>
            </template>
            <template v-if="!day.aaron.eveningStack.name">
              <span class="none">-</span>
            </template>
            <br>
            <template v-if="day.ronan.eveningStack.name">
              <span class="ronan">{{ day.ronan.eveningStack.name }}</span>
            </template>
            <template v-if="!day.ronan.eveningStack.name">
              <span class="none">-</span>
            </template>
          </td>
          <td>
            <template v-if="day.aaron.dinner.name">
              <span class="dad">{{ day.aaron.dinner.name }}</span>
            </template>
            <template v-if="!day.aaron.dinner.name">
              <span class="none">-</span>
            </template>
            <br>
            <template v-if="day.ronan.dinner.name">
              <span class="ronan">{{ day.ronan.dinner.name }}</span>
            </template>
            <template v-if="!day.ronan.dinner.name">
              <span class="none">-</span>
            </template>
          </td>
          <td>
            <template v-if="day.aaron.eveningSnack.name">
              <span class="dad">{{ day.aaron.eveningSnack.name }}</span>
            </template>
            <template v-if="!day.aaron.eveningSnack.name">
              <span class="none">-</span>
            </template>
            <br>
            <template v-if="day.ronan.eveningSnack.name">
              <span class="ronan">{{ day.ronan.eveningSnack.name }}</span>
            </template>
            <template v-if="!day.ronan.eveningSnack.name">
              <span class="none">-</span>
            </template>
          </td>
          <td>
            <span class="dad">
              {{ Math.round(
                ((day.aaron.morningStack.calories || 0) * (day.aaron.morningStack.portion || 0)) +
                ((day.aaron.breakfast.calories || 0) * (day.aaron.breakfast.portion || 0)) +
                ((day.aaron.morningSnack.calories || 0) * (day.aaron.morningSnack.portion || 0)) +
                ((day.aaron.afternoonStack.calories || 0) * (day.aaron.afternoonStack.portion || 0)) +
                ((day.aaron.lunch.calories || 0) * (day.aaron.lunch.portion || 0)) +
                ((day.aaron.afternoonSnack.calories || 0) * (day.aaron.afternoonSnack.portion || 0)) +
                ((day.aaron.eveningStack.calories || 0) * (day.aaron.eveningStack.portion || 0)) +
                ((day.aaron.dinner.calories || 0) * (day.aaron.dinner.portion || 0)) +
                ((day.aaron.eveningSnack.calories || 0) * (day.aaron.eveningSnack.portion || 0))
              ) }} cal
            </span><br>
            <span class="ronan">
              {{ Math.round(
                ((day.ronan.morningStack.calories || 0) * (day.ronan.morningStack.portion || 0)) +
                ((day.ronan.breakfast.calories || 0) * (day.ronan.breakfast.portion || 0)) +
                ((day.ronan.morningSnack.calories || 0) * (day.ronan.morningSnack.portion || 0)) +
                ((day.ronan.afternoonStack.calories || 0) * (day.ronan.afternoonStack.portion || 0)) +
                ((day.ronan.lunch.calories || 0) * (day.ronan.lunch.portion || 0)) +
                ((day.ronan.afternoonSnack.calories || 0) * (day.ronan.afternoonSnack.portion || 0)) +
                ((day.ronan.eveningStack.calories || 0) * (day.ronan.eveningStack.portion || 0)) +
                ((day.ronan.dinner.calories || 0) * (day.ronan.dinner.portion || 0)) +
                ((day.ronan.eveningSnack.calories || 0) * (day.ronan.eveningSnack.portion || 0))
              ) }} cal
            </span>
          </td>
        </tr>
      </table>
    </v-card>
  </div>
</template>

<script>
import db from '@/firebase/firestore'
import moment from 'moment'
export default {
  name: 'Fuel',
  data() {
    return {
      loading: true,
      plan: [],
      day: 0
    }
  },
  computed: {
    orderedPlan: function() {
      return _.orderBy(this.plan,'day')
    }
  },
  methods: {
    highlight: function(day) {
      if( day == this.day ) return 'today'
    }
  },
  created () {
    // Calculate Day
    this.day = moment(moment().diff('10/1/2018')).format('DDD') % 14
    if( this.day == 0 ) this.day = 14
    console.log( this.day )
    // Load Plan
    let planRef = db.collection('plan')
    planRef.get().then((snapshot) => {
      snapshot.forEach( doc => {
        let data = doc.data()
        this.plan.push(data)
      })
      this.loading = false
    })
  }
}
</script>

<style>
.fuel {
  padding: 10px;
}
.fuel .table-card {
  padding: 20px;
}
.fuel table {
  border: 1px solid #607d8b;
}
.fuel td, th {
  border: 1px solid #f5f5f5;
  font-size: 10px;
  text-align: center;
  padding: 5px;
}
.fuel th { 
  background: #f5f5f5;
}

table {
  border-collapse: collapse;
  width: 100%;
}

th {
  height: 50px;
}
.today {
  background: #fffddc;
}
.dad {
  color: blue;
}
.ronan {
  color: red;
}
.none {
  color: #c4c4c4;
}
.avatar {
    width: 20px;
    height: 20px;
    display: inline-block;
}
.avatar-sm {
    width: 18px;
    height: 18px;
    padding-right: 2px;
}
.avatar-sm.ghost img {
  opacity: 0.25;
}
.avatar img {
  height: 100%;
}
.avatar.ghost img {
  -webkit-filter: grayscale(1);
}
.activity {
  display: inline-block;
  border-left: 1px solid whitesmoke;
  height: 20px;
  margin: 0 5px;
}
.groceries {
  color: green;
  display: block;
  text-decoration: none;
}
.groceries:hover {
  text-decoration: underline;
}
</style>
